export enum ReportEntity {
  EMPLOYEES = "EMPLOYEES",
  TRANSACTIONS = "TRANSACTIONS",
  CARDS = "CARDS"
}
